module.exports = __webpack_public_path__ + "assets/master-slider.ec381fdf.svg";